import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customTitlecase',
})
export class CustomTitlecasePipe implements PipeTransform {
  private exceptions = ['of', 'and', 'the', 'in', 'on', 'at', 'with', 'by', 'for']; 

  transform(value: string): string {
    if (!value) return value;
    const words = value.toLowerCase().split(' ');
    const formattedWords = words.map((word, index) => {
      if (index === 0 || !this.exceptions.includes(word)) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }
      return word;
    });

    return formattedWords.join(' ');
  }
}
